import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import styles from "./IconButton.module.scss";
export default function IconButton(_a) {
    var { Icon } = _a, props = __rest(_a, ["Icon"]);
    return (_jsx(Icon, Object.assign({}, props, { className: clsx(styles.iconButton, props.className) })));
}
